"use strict";
var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedcareplansectionflat",
	init: init,
	listeners: listeners,
});

function init() {
	this.push();
}

function listeners() {
	return {
		"managedcareplansection:updated": handle_careplan_section_updated,
	};
}

function handle_careplan_section_updated(section) {
	this.push(recompute("/", section, {}));
}

function recompute(prefix, section, current) {
	return Object.keys(section).reduce(function(result, key){
		var value = section[key];
		var resultKey = prefix + key;
		var resultValue = value;
		if(typeof value === "object")
			recompute(resultKey + "/", value, result);
		else
			result[resultKey] = resultValue;

		return result;
	}, current);
}
